import { IExperiment } from '../models/experiments';

export enum EAbFiltersGroup {
  /** Контрольная группа, никаких изменений */
  NothingChanged = 0,
  /** Новые фильтры */
  NewFilters = 1,
}

export const getFiltersGroup = (experiments: IExperiment[]): EAbFiltersGroup => {
  const abFiltersExperiment = experiments.find((e) => e.name === 'audience_mainpage_filters');

  return abFiltersExperiment && abFiltersExperiment.abGroup || 0;
};
